import type { InlineConversationBrief } from "@/hooks/useInlineConversation";

/** Parse /chat-style URL params into an InlineConcierge initial brief. */
export function buildInitialBriefFromSearchParams(
  params: URLSearchParams,
): InlineConversationBrief | null {
  const brief: Record<string, unknown> = {};
  const text = params.get("brief");
  if (text) brief.raw_text = text;
  const recipient = params.get("recipient");
  if (recipient) brief.recipient_name = recipient;
  const recipientId = params.get("recipientId");
  if (recipientId) brief.recipient_id = recipientId;
  const occasion = params.get("occasion");
  if (occasion) brief.occasion = occasion;
  const category = params.get("category");
  if (category) brief.vendor_category = category;
  const inspiredBy = params.get("inspired_by");
  if (inspiredBy && !brief.vendor_category) brief.vendor_category = inspiredBy;
  const budget = params.get("budget");
  if (budget && !Number.isNaN(Number(budget))) brief.budget_aud = Number(budget);
  return Object.keys(brief).length > 0 ? (brief as InlineConversationBrief) : null;
}

/** Strip `?…` from a `/chat?…` URL and return the query string params. */
export function chatQueryFromUrl(chatUrl: string): URLSearchParams {
  const [, query = ""] = chatUrl.split("?", 2);
  return new URLSearchParams(query);
}
